export default "__VITE_ASSET__R$NsKUAC__"